// extracted by mini-css-extract-plugin
module.exports = {"LogoWithTypeFace":"LogoWithTypeFace_LogoWithTypeFace__3JkTD","LogoTypeFace":"LogoWithTypeFace_LogoTypeFace__2-F-k"};